import Component, { mixins } from 'vue-class-component'

import HttpStatusCode from 'http-status-codes'

import WithRender from './ErrorPage.html'

import { 
  MErrorAccessDenied,
  MErrorPageNotFound,
  MErrorResourceUnavailable,
  MErrorTechnicalDifficulty
} from '@ulaval/modul-components'
import { STORE_GETTERS } from '@/store'

import IInscriptionLieuExamenInformations from '@/modules/inscription-lieu-examen/IInscriptionLieuExamenInformations.model'
import IDossierEtudiant from '@/modules/inscription-lieu-examen/IDossierEtudiant.model'

@WithRender
@Component({
  components: {
    MErrorAccessDenied,
    MErrorPageNotFound,
    MErrorResourceUnavailable,
    MErrorTechnicalDifficulty
  }
})
export default class ErrorPage extends mixins() {
  private get dossierEtudiant(): IDossierEtudiant | null {
    return this.$store.getters[STORE_GETTERS.INSCRIPTION_LIEU_EXAMEN_GET_DOSSIER_ETUDIANT]
  }

  private get inscriptionLieuExamenInformations(): IInscriptionLieuExamenInformations | null {
    return this.$store.getters[STORE_GETTERS.INSCRIPTION_LIEU_EXAMEN_GET_INFORMATIONS]
  }

  private get token(): string {
    return this.$store.getters[STORE_GETTERS.INSCRIPTION_LIEU_EXAMEN_GET_TOKEN]
  }

  private get status(): string {
    return this.$route.params.status ? 
      this.$route.params.status.toString() : 
      HttpStatusCode.SERVICE_UNAVAILABLE.toString()
  }

  private get errorPageComponent(): object {
    if (this.status) {
      if (this.status === HttpStatusCode.NOT_FOUND.toString()) {
        return MErrorPageNotFound
      } else if (
        this.status === HttpStatusCode.UNAUTHORIZED.toString() || 
        this.status === HttpStatusCode.FORBIDDEN.toString()
      ) {
        return MErrorAccessDenied
      } else if (this.status === HttpStatusCode.INTERNAL_SERVER_ERROR.toString()) {
        return MErrorTechnicalDifficulty
      }
    }

    return MErrorResourceUnavailable
  }

  private get hints(): string[] {
    return this.$i18next.t(`modules.global.error.ErrorPage.status.${this.status}.hints`, { returnObjects: true })
  }

  private get links(): string [] {
    return [
      ...this.$i18next.t(`modules.global.error.ErrorPage.status.${this.status}.links`, { returnObjects: true }),
      ...this.$i18next.t(`modules.global.error.ErrorPage.global_links`, {
        returnObjects: true, 
        'dossierEtudiant': this.dossierEtudiant,
        'inscriptionLieuExamenInformations': this.inscriptionLieuExamenInformations,
        'token': this.token
      })
    ]
  }

  private get title(): string {
    return this.$i18next.t(`modules.global.error.ErrorPage.status.${this.status}.title`)
  }
}
